export const SESSION_LIST = 'SESSION_LIST';
export const SESSION_USER_INFO = 'SESSION_USER_INFO';
